import { render, staticRenderFns } from "./comCard3.vue?vue&type=template&id=70eda812&scoped=true&"
import script from "./comCard3.vue?vue&type=script&lang=js&"
export * from "./comCard3.vue?vue&type=script&lang=js&"
import style0 from "./comCard3.vue?vue&type=style&index=0&id=70eda812&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70eda812",
  null
  
)

export default component.exports